export interface MaterialUnitType {
    id: number;
    unit_name: string | null;
    status: 1 | 0;
}

// to single object maping
export const mapMaterialUnitType = (data: any): MaterialUnitType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialUnitType: MaterialUnitType = {
        id: data.id,
        unit_name: data.unit_name || null,
        status: data.status,
    }

    return materialUnitType;
}

// maping list objects
export const mapMaterialUnitTypes = (data: any[]): MaterialUnitType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialUnitType);
}